import world from "./world";
import clear from "./clear";

export default {
  commands: {
    world,
    clear
  },
};
